import { loadNotifications, markNotificationAsConfirmed } from "../actions/notifications.js";

import AllNotificationsModal from "../components/AllNotificationsModal.jsx";
import {connect} from "react-redux";
import { createLocalization } from "../util/localization.jsx";
import { createReselector } from "../util/reselect.js";
import moment from "moment";
import {setModal} from "../actions/modal";

const mapStateToProps = (state) => {
    const notificationsReselector = createReselector((notifications) => {
        const sorted = [...Object.values(notifications).map(n => ({
            ...n,
            fromDate: moment(n.fromDate)
        }))];

        sorted.sort((a, b) => b.fromDate.diff(a.fromDate));

        const NOTIFICATIONS_TO_SHOW = 25;

        const groupedNotifications = [];

        const currentDate = moment().startOf("date");
        let group = null;

        for (let i = 0; (i < NOTIFICATIONS_TO_SHOW && i < sorted.length); i++) {
            const n = sorted[i];
            const diff = moment.duration(currentDate.diff(n.fromDate));
            const daysAgo = Math.max(0, diff.days());
            const monthsAgo = Math.max(0, diff.months());
            const yearsAgo = Math.max(0, diff.years());

            if (!group || (yearsAgo !== group.yearsAgo) || (yearsAgo === 0 && monthsAgo !== group.monthsAgo) || (yearsAgo === 0 && monthsAgo === 0 && daysAgo !== group.daysAgo)) {
                group = {
                    daysAgo,
                    monthsAgo,
                    yearsAgo,
                    notifications: [n]
                };

                groupedNotifications.push(group);
            } else {
                group.notifications.push(n);
            }
        }

        return groupedNotifications;
    });

    return {
        localization: createLocalization(state),
        groupedNotifications: notificationsReselector(state.notifications.notifications)
    };
};

const mapDispatchToProps = {
    loadNotifications,
    markNotificationAsConfirmed,
    setModal
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});


export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AllNotificationsModal);